<template>
  <div class="partner-registration-form-layout">
    <div class="partner-registration-form-layout__header">
      <h2 class="partner-registration-form-layout__title">
        {{ title }}
      </h2>
      <slot name="content" />
      <PartnerRegistrationFormFooter />
    </div>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  title: string
}>()
</script>

<style lang="postcss" scoped>
.partner-registration-form-layout {
  @apply min-h-screen bg-[#012526] px-4 md:px-8;
}

.partner-registration-form-layout__header {
  @apply max-w-6xl mx-auto;
}

.partner-registration-form-layout__title {
  @apply text-xl md:text-2xl font-semibold text-white text-center py-12;
}
</style>
